<pds-module-header title="Dialetos" [ctaLabel]="allowToCreateQuery ? 'Novo Dialeto' : ''" [ctaPath]="allowToCreateQuery ? '/query/create-query' : ''">
  <pds-new-breadcrumb [items]="breadcrumb"></pds-new-breadcrumb>

  <pds-panel>
    <pds-form [formGroup]="form" (ngSubmit)="search()">
      <pds-form-row>
        <pds-form-field label="Pesquisar">
          <input placeholder="Pesquise por nome" type="text" formControlName="search" />
        </pds-form-field>
      </pds-form-row>
      <pds-form-actions>
        <button pdsButton (click)="search()">Buscar</button>
      </pds-form-actions>
    </pds-form>

    <hr />

    @if (hasItems() && !loading) {
    <pds-table>
      <table>
        <thead>
          <th>Nome</th>
          <th>Grupo</th>
          <th>Status</th>
          <th></th>
        </thead>
        <tbody>
          <tr *ngFor="let query of queriesResponse?.items">
            <td>{{ query.query }}</td>
            <td>
              @for (item of query.filter.productGroups; track $index) {
              <span pdsChip>{{ item.name }}</span>
              }
            </td>
            <td class="action-col" *allowTo="[['dialect-query-excluir']]">
              <div class="container-active">
                <pds-switch [(ngModel)]="query.active" (ngModelChange)="onClickActive($event, query.id)" pdsButton="icon"> </pds-switch>
              </div>
            </td>
            <td pdsColActions>
              <a [routerLink]="['/query', query.id]">
                <button pdsButton="icon">
                  <span class="icon">visibility</span>
                </button>
              </a>
              <button pdsButton="icon" (click)="delete(query)">
                <span class="icon">delete</span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <pds-pagination [pagination]="pagination$" (paginate)="onPageChange($event)"></pds-pagination>
    </pds-table>
    }@else if (loading) {
    <strong>Carregando...</strong>
    }@else if (!hasItems()) {
    <strong>Nenhuma query encontrada</strong>
    }@else {
    <strong>Falha ao listar queries</strong>
    }
  </pds-panel>
</pds-module-header>
